import React, { useContext, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import callAPI from "../../../../../../api/apiCaller";
import { useParams } from "react-router-dom";
import { Context } from "../../../../../../Store";
import {
  SuggestedContainer,
  ProfileImage,
  Image,
  Percentage,
  ProfileName,
  AssignButton,
  SuggestedContainerInner,
  SuggestedContainerOuter,
} from "../style";
import MenteeMatch from "../../ReassignMentee/MenteeMatch";

const MatchMakingSlider = ({
  matchedMentors,
  mentee,
  setMatchedParticipants,
  matchedParticipants,
  matchModal,
  setMatchModal,
  closeModal,
  successModal,
  setSuccessModal,
}) => {
  const params = useParams();
  const { dispatch } = useContext(Context);
  const [programParticipants, setProgramParticipants] = useState([]);
  var settings = {
    dots: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    easing: "linear",
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  function reassignMentee(mentorId, uniqueMenteeId) {
    callAPI(dispatch, "reassignMentee", {
      id: params.selectedProgram,
      mentorId: mentorId,
      menteeId: uniqueMenteeId,
    }).then((res) => {
      setSuccessModal(true);
    });
  }

  React.useEffect(() => {
    const data = {
      id: params.selectedProgram,
      search: null,
      status: null,
    };
    callAPI(dispatch, "getSearchMentorProgramParticipants", data).then(
      (retrievedRequests) => {
        if (retrievedRequests.isResponseOk) {
          console.log("retrievedRequests:", retrievedRequests);

          setProgramParticipants(retrievedRequests.data.active.mentors);
        } else setProgramParticipants(null);
      }
    );
  }, []);

  const onClickAssign = (mentee, item) => {
    console.log("programParticipants:", programParticipants);

    const matchedParticipant = programParticipants.find((participant) => {
      return participant.participantId === item.id;
    });
    if (matchedParticipant) {
      setMatchedParticipants([mentee, matchedParticipant]);
      setMatchModal(true);
    }
  };

  return (
    <>
      {matchedMentors.length > 3 ? (
        <Slider {...settings}>
          {matchedMentors &&
            matchedMentors.map((item) => {
              return (
                <>
                  <SuggestedContainer>
                    <SuggestedContainerInner>
                      <ProfileImage>
                        <Image
                          src={
                            item.image
                              ? item?.image
                              : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                          }
                        />
                        <Percentage>{item.percentage}</Percentage>
                      </ProfileImage>
                      <ProfileName>
                        {item.firstName} {item.lastName}
                      </ProfileName>
                      <AssignButton
                        onClick={() => {
                          onClickAssign(mentee, item);
                        }}
                      >
                        Assign
                      </AssignButton>
                    </SuggestedContainerInner>
                  </SuggestedContainer>
                </>
              );
            })}
        </Slider>
      ) : (
        <SuggestedContainerOuter>
          {matchedMentors &&
            matchedMentors.map((item, index) => {
              return (
                <SuggestedContainer key={index}>
                  <SuggestedContainerInner>
                    <ProfileImage>
                      <Image
                        src={
                          item.image
                            ? item?.image
                            : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                        }
                      />
                      <Percentage>{item.percentage}%</Percentage>
                    </ProfileImage>
                    <ProfileName>
                      {item.firstName} {item.lastName}
                    </ProfileName>
                    <AssignButton
                      onClick={() => {
                        onClickAssign(mentee, item);
                      }}
                    >
                      Assign
                    </AssignButton>
                  </SuggestedContainerInner>
                </SuggestedContainer>
              );
            })}
        </SuggestedContainerOuter>
      )}
      <MenteeMatch
        reassignMentee={reassignMentee}
        matchedParticipants={matchedParticipants}
        isOpen={matchModal}
        closeModal={() => {
          setMatchModal(false);
          closeModal(false);
        }}
        isClose={closeModal}
        successModal={successModal}
        setSuccessModal={setSuccessModal}
      />
    </>
  );
};

export default MatchMakingSlider;
